<script>

import { Line , mixins} from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  name: 'HeatStrokeBarChart',
  extends: Line,
  mixins:[reactiveProp],
  props: [
    'chartData',
    'upperDataString',
    'lowerDataString',
    'optionsXAxesTicksMin',
    'optionsXAxesTicksMax',
    'temperatureSelect'
  ],
  data(){
    return {
      options: {
        chartArea: {
          backgraundColor: '#fff'
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            filter: function (chartData) {
              return chartData.text != 'upper' && chartData.text != 'lower'
            }
          },
          onClick: function (e, legendItem) {
            const index = legendItem.datasetIndex;
            var chart = this.chart;
            var allHidden = true;
            var isHidden = chart.data.datasets[index].hidden;

            var isAllVisible = false;

            // クリックしたデータが非表示の場合
            if (isHidden) {
              // その他のデータは非表示
              allHidden = true;
            } else {
              // クリックしたデータが表示の場合
              isAllVisible = chart.data.datasets.every(function (dataset) {
                if (dataset.label == 'upper' || dataset.label == 'lower') {
                  return true
                } else {
                  return !dataset.hidden;
                }
              });

              if (isAllVisible) {
                allHidden = true;
              } else {
                allHidden = false;
              }
            }

            //全てを表示
            chart.data.datasets.forEach(function (dataset) {
              if (dataset.label == 'upper' || dataset.label == 'lower') {
                dataset.hidden = true;
              } else {
                dataset.hidden = allHidden;
              }
              if (isAllVisible || isHidden) {
                if (dataset.label == 'upper' || dataset.label == 'lower') {
                  if (chart.data.datasets[index]["sensorKbnId"] === dataset["sensorKbnId"]) {
                    dataset.hidden = false;
                  }
                }
              }
            });

            // クリックしたデータセットを表示
            chart.data.datasets[index].hidden = false;
            chart.update();
          },
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
            },
            type: 'time',
            time: {
              parser: "YYYY/MM/DD hh:mm",
              tooltipFormat: "DD日 hh:mm A",
              displayFormats: {
                minute: 'h:mm a'
              },
              unit: 'hour'
            },
            ticks: {
              min: "",
              max: ""
            },
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1
            }
          }]
        },
        plugins: {
          datalabels: {
            display: false
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            beforeLabel: function (tooltipItem, data) {
              return data.datasets[tooltipItem.datasetIndex].location[tooltipItem.index];
            },
            label: function (tooltipItem, data) {
              return data.datasets[tooltipItem.datasetIndex].sensorId[tooltipItem.index] + " " + tooltipItem.yLabel +
                  data.datasets[tooltipItem.datasetIndex].selectUnit[tooltipItem.index];
            },
            afterLabel: function (tooltipItem, data) {
              if (data.datasets.staffName != '') {
                return data.datasets[tooltipItem.datasetIndex].staffName[tooltipItem.index];
              }
            }
          }
        },
        maintainAspectRatio: false,
        onClick: function (event) {
          var chart = this.chart;
          //選択したデータポイントを取得
          var points = chart.getElementsAtEventForMode(event, 'nearest', {intersect: true}, true);
          if (points.length === 0) {
            return;
          }
          var point = points[0];
          var datasetIndex = point['_datasetIndex'];
          //選択したデータの種別を取得
          var selectKbnId = point['_chart'].data.datasets[0].sensorKbnId;

          //選択済みのデータの判定
          var isAllVisible = false;
          isAllVisible = chart.data.datasets.every(function (dataset) {
            if (dataset.label == 'upper' || dataset.label == 'lower') {
              return true
            } else {
              return !dataset.hidden;
            }
          });

          //選択済みのデータが無い場合
          if (isAllVisible) {
            //選択したデータのみ表示
            chart.data.datasets.forEach(function (dataset, i) {
              if (dataset.label != 'upper' && dataset.label != 'lower') {
                dataset.hidden = i !== datasetIndex;
              }
              //選択したデータの種別のみ閾値表示
              else {
                dataset.hidden = selectKbnId !== dataset["sensorKbnId"];
              }
            });
          }
          //選択済みのデータがある場合
          else {
            chart.data.datasets.forEach(function (dataset) {
              if (dataset.label == 'upper' || dataset.label == 'lower') {
                dataset.hidden = true;
              } else {
                dataset.hidden = false;
              }
            });
          }
          chart.update();
        },
      }
    }
  },
  created() {
    this.options.scales.xAxes[0].ticks.min = this.optionsXAxesTicksMin;
    this.options.scales.xAxes[0].ticks.max = this.optionsXAxesTicksMax;
  },
  mounted () {
    this.options.scales.xAxes[0].ticks.min = this.optionsXAxesTicksMin;
    this.options.scales.xAxes[0].ticks.max = this.optionsXAxesTicksMax;
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    temperatureSelect() {
      this.renderSensorMap()
    }
  },
  methods: {
    //ヒートマップ描画
    renderSensorMap() {
      this.options.scales.xAxes[0].ticks.min = this.optionsXAxesTicksMin;
      this.options.scales.xAxes[0].ticks.max = this.optionsXAxesTicksMax;
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>